import React, { useState, useEffect } from "react";
import { Table, Form } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

export default function CourseFees() {
  const [marginLeft, setMarginLeft] = useState(
    window.innerWidth > 768 ? "270px" : "0px"
  );

  useEffect(() => {
    const handleResize = () => {
      setMarginLeft(window.innerWidth > 768 ? "270px" : "0px");
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <div style={{ marginLeft}}>
      <h2 className="text-center p-4 bg-secondary rounded shadow text-white mt-md-0 mt-5">
        Institute Fee Structure
      </h2>
      <div className="d-flex justify-content-center mb-3">
        {/* <Form.Select className="w-50 shadow">
          <option value="">Select a Course</option>
        </Form.Select> */}
      </div>

      <div>
        <Container>
          <Row>
            <Col className="text-start">
              <Form.Label className="fw-bold text-start">
                Select Course
              </Form.Label>

              <Form.Select aria-label="Default select example">
                <option>Basic</option>
                <option value="1">Phython</option>
                <option value="2">Digital Marketing</option>
                <option value="3">Java</option>
              </Form.Select>
            </Col>
          </Row>
        </Container>
      </div>
      <div className="d-flex justify-content-center mt-3">
        <div className="w-100 rounded bg-light p-3 shadow">
          <Table bordered hover responsive className="text-center">
            <thead className="bg-dark text-white">
              <tr>
                <th>Course Name</th>
                <th>Duration</th>
                <th>Description</th>
                <th>Total Course Fee</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>Full Stack Development</td>
                <td>6 Months</td>
                <td>
                  Learn front-end & back-end development with real-world
                  projects.
                </td>
                <td>$1200</td>
              </tr>
              <tr>
                <td>React Mastery</td>
                <td>3 Months</td>
                <td>
                  Master ReactJS with hands-on projects and advanced concepts.
                </td>
                <td>$800</td>
              </tr>
              <tr>
                <td>Data Structures & Algorithms</td>
                <td>4 Months</td>
                <td>
                  Improve problem-solving skills with DSA using C++ & Java.
                </td>
                <td>$1000</td>
              </tr>
            </tbody>
          </Table>
        </div>
      </div>
    </div>
  );
}
